import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { READ_TIME_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';
export const READ_TIME_METRIC = createPageSegmentLoadMetric({
	key: READ_TIME_SEGMENT_KEY,
});
